"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClientForm_1 = require("./ClientForm");
exports.ClientForm = ClientForm_1.default;
var ClientFormInfo_1 = require("./ClientFormInfo");
exports.ClientFormInfo = ClientFormInfo_1.default;
//# sourceMappingURL=index.js.map